import { useAuth } from "../../context/AuthContext";
import { Redirect } from "react-router-dom";
import React from "react";


const PrivateRoute = ({ children }) => {
    const { token } = useAuth();  // Verificando se o usuário está autenticado
   
    
    if (!token) {
        return <Redirect to="/" />;  // Redireciona para a página de login caso não autenticado
    }
    return children;  // Renderiza o componente filho se estiver autenticado
};

export default PrivateRoute;
